import React, { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = memo(({ onNavigate }) => {
  const { i18n, t } = useTranslation();
  const lang = useMemo(
    () => (i18n.language?.startsWith("ar") ? "ar" : "en"),
    [i18n.language]
  );

  const targetLang = lang === "en" ? "ar" : "en";
  const visibleLabel = targetLang === "ar" ? "عربي" : "EN";
  const ariaLabel =
    targetLang === "ar" ? t("lang.switchToArabic") : t("lang.switchToEnglish");

  const className =
    targetLang === "ar"
      ? "vh-lang-switcher vh-lang-switcher--tajawal"
      : "vh-lang-switcher";

  return (
    <button
      type="button"
      className={className}
      dir="ltr"
      onClick={() => {
        onNavigate?.();
        i18n.changeLanguage(targetLang);
      }}
      aria-label={ariaLabel}
    >
      {visibleLabel}
    </button>
  );
});

export default LanguageSwitcher;
